import Node from 'ln/node/Node';
import View from 'ln/view/View';
import ModifiableList from 'ln/list/ModifiableList';

class TagFilterView extends View {

	public title:string;
	private _comparisonAttribute:string;
	private modifiableList:ModifiableList<any>;
	private selectedTags:any[];
	
	constructor( modifiableList:ModifiableList<any>, template:string = 'krw.courselistfilter-tagfilter' ) {
		super();
		this.selectedTags = [];
		this.modifiableList = modifiableList;
		this.modifiableList.modifiers.append( this.filter.bind( this ) )
		this.defaultTemplate = template;
	}
	
	public init() {

		var tagNodes = this.node.all( '.btn' );
		tagNodes.forEach( function( tag ) {
			tag.click.add( this.onChange, this );
		}, this );

	}

	public renderData(){
		return { title: this.title, tags: this.getAvaliableTags() };
	}
	
	private onChange( targetNode:Node ) {

		targetNode.native.blur();
		targetNode.toggleClass( 'active' );		
		// get all active tags
		var activeNodes = this.node.all( '.active' );
		this.selectedTags = this.node.all( '.active' ).map( node => node.getAttribute( 'id' ) );
		
		this.modifiableList.update();	
	}
	
	private filter( items:any[]):any[] {

		// nothing to do if nothing is selected
		if( this.selectedTags.length == 0 ) return items;

		return items.filter( ( item, index ) => {

			/* if( item[ 'origin' ] ) {
				var tag = <string[]>item[ 'origin' ][ this.comparisonAttribute ] 
			} else { */
				var tag = <string[]>item[ this.comparisonAttribute ];
			/* } */

			return this.selectedTags.indexOf( tag ) != -1;		
		} );

	}
	
	private getAvaliableTags() {
		var tags = [];		
		this.modifiableList.all().forEach( function( item ) {

			/* if( item[ 'origin' ] ) {
				var tag = item[ 'origin' ][ this.comparisonAttribute ] ;
			}else { */
				var tag = item[ this.comparisonAttribute ];
			/* } */
			if( tag && tags.indexOf( tag ) == -1 ) {
				tags.push( tag );
			}
		}, this);
		
		return tags.sort();
	}
	
	set comparisonAttribute( c:string ) {
		this._comparisonAttribute = c;
	}
	
	get comparisonAttribute():string {
		return this._comparisonAttribute;
	}	

}

export default TagFilterView;